export default __webpack_public_path__ + "static/interactive-brand-presentations@2x-359ba1fda62aeede0fa25d39cb735eaa.png";